import { makeSelector } from "../../../testing/index.js";
import { WdioWrapper } from "../../../testing/wdio.js";
const TestingAttrs = {
  radioInput: "data-radio-input"
};
const ToggleButtonSelectors = {
  radioInput: makeSelector("Radio input", TestingAttrs.radioInput)
};
const DsfToggleButtonWrapper = (parentSelector) => WdioWrapper(parentSelector, ToggleButtonSelectors);
export {
  DsfToggleButtonWrapper,
  TestingAttrs,
  ToggleButtonSelectors
};
